var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnonymous(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.319,
    height: 143.138,
    viewBox: "0 0 122.319 143.138",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Anonymous",
    transform: "translate(-28.929 -17.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M68.491,87.892a38.488,38.488,0,1,1,43.118.1c.821.349,1.6.651,2.348,1.007q35.129,16.32,37.182,54.991c.186,3.666.085,7.354.039,11.035-.046,3.782-1.992,5.688-5.789,5.688q-55.366.012-110.74,0c-3.681,0-5.7-1.953-5.68-5.58.023-7.8-.465-15.623,1.441-23.3,5.076-20.412,17.2-34.842,36.554-43.142.411-.178.829-.356,1.232-.55a1.627,1.627,0,0,0,.287-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M98.48,65.025V62.7c.023-3.96,1.434-5.541,5.432-6.068a4.086,4.086,0,0,0,3.728-4.192,4.03,4.03,0,0,0-3.782-3.929,4.081,4.081,0,0,0-4.324,3.58c-.039.256-.031.511-.07.775a5.2,5.2,0,0,1-5.487,4.843,5.265,5.265,0,0,1-4.75-5.789,14.32,14.32,0,1,1,21.125,13.213,2.47,2.47,0,0,0-1.643,2.6c.07,3.472-2.046,5.781-5.091,5.789-3.077,0-5.091-2.263-5.13-5.773-.008-.907,0-1.806,0-2.712Z",
    transform: "translate(-13.568 -4.652)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M106.34,85.51a5.1,5.1,0,1,1-.147,10.191,5.1,5.1,0,1,1,.147-10.191Z",
    transform: "translate(-16.251 -15.287)",
    fill: "#fdfdfd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnonymous);
export default __webpack_public_path__ + "static/media/Anonymous.d6ca668593f00bd9297628b8dc820e8d.svg";
export { ForwardRef as ReactComponent };